import { Base, Component } from '@/vue-property-decorator'
import { Tooltip } from '@/plugins/ant-design-vue/tsx-support'
import { useFooterStore } from '../../store'
import { useI18n } from '@/i18n'
import { useMainStore } from '@/store/index'
import BusinessUtils from '@/utils/business-utils'
import style from './style.module.scss'

export interface Props {
  long?: number
  showTitle?: boolean
}

@Component<CopyShare>({
  name: 'CopyShare'
})
export default class CopyShare extends Base {
  store = useFooterStore()
  private get footerInfos() {
    return this.store.footerInfos
  }

  private renderCopyRight() {
    const { t } = useI18n()

    const { isWeb } = useMainStore()
    if (this.footerInfos?.contactInfo) {
      const { isDefault, copyrightInfo, contactContent, customCopyrightInfo } =
        this.footerInfos.contactInfo
      let copyRightList =
        isDefault && copyrightInfo
          ? [...contactContent, t(`lobby.footer.copyright`)]
          : [...contactContent, customCopyrightInfo]
      copyRightList = copyRightList.filter((item) => String(item).trim() !== '')
      const maxWidth = BusinessUtils.px2rem(1200 / copyRightList.length)
      return (
        <div class={style.copyRight}>
          <ul>
            {copyRightList.map((item, index) => {
              let liStyle: Record<string, unknown> = { maxWidth }
              if (!isWeb && copyRightList.length > 1) {
                const mobWidth =
                  copyRightList.length % 2 === 1 &&
                  index === copyRightList.length - 1
                    ? '100%'
                    : '50%'
                liStyle = {
                  width: mobWidth
                }
              }

              return (
                <li style={liStyle} key={index}>
                  <Tooltip.Tsx
                    placement="top"
                    overlayStyle={{ maxWidth: 'unset' }}
                  >
                    <inner-html type="p" text={item} />
                  </Tooltip.Tsx>
                </li>
              )
            })}
          </ul>
        </div>
      )
    }
  }
  render() {
    if (this.footerInfos?.contactInfoStatus) {
      return <template></template>
    }
    return (
      <div class={[style.copyRight, 'copy-right']}>
        {this.renderCopyRight()}
      </div>
    )
  }
}
